import React from 'react'
import Dot from './Dot';

class DotPagination extends React.Component {
    constructor(props){
        super(props)

        this._renderDots = this._renderDots.bind(this);
    }

    _renderDots(pages){
        let dots = [];

        for (let index = 0; index < pages; index++) {

            if(index+1 === this.props.activePage){
                dots.push(<Dot key={index+1} active={true}/>)
            }else{
                dots.push(<Dot key={index+1} active={false}/>)
            }
        }

        return dots;
    }

    render() {
        const {pages} = this.props
        return this._renderDots(pages)
    }
}

DotPagination.propTypes = {

}


export default DotPagination



// WEBPACK FOOTER //
// ./src/component/DotPagination/index.js